<template>
<app-content>
    <form action="#">
    <div class="inner">
        <p class="buttons">
        <app-button-delete @click="deleteItem" v-if="!newItem" />
        </p>
        <app-content-title v-if="!newItem" :title="item.name" />
        <app-content-title v-if="newItem" :title="translations.newImageSize" />
    </div>

    <app-settings @submit="submitForm" :disabled="pending">
        <app-settings-content>
        <app-settings-desc :title="translations.basicInfo">
            <p>
            <translate>Založeno</translate>:
            <br />
            <span v-html="formatDateAdvanced(item._created)" />
            </p>
            <p>
            <translate>Poslední změna</translate>:
            <br />
            <span v-html="formatDateAdvanced(item._updated)" />
            </p>
        </app-settings-desc>
        <app-settings-options>
            <app-settings-col class="field_left">
            <app-input
                required
                :label="translations.name"
                :error="errors.items.find(el => el.field === 'name')"
                name="name"
                v-model="formItem.name"
            />
            </app-settings-col>
            <app-settings-col class="field_right">
                <app-input
                    required
                    :label="translations.code"
                    :error="errors.items.find(el => el.field === 'code')"
                    name="code"
                    v-model="formItem.code"
                />
            </app-settings-col>
            <app-settings-col class="field_left">
            <app-input
                required
                :label="translations.compression"
                :error="errors.items.find(el => el.field === 'compression')"
                name="compression"
                type="number"
                v-model="formItem.compression"
            />
            </app-settings-col>
            <app-settings-col class="field_right">
              <app-input
                  :label="translations.radius"
                  :error="errors.items.find(el => el.field === 'radius')"
                  name="radius"
                  type="number"
                  v-model="formItem.radius"
              />
            </app-settings-col>
            <app-settings-col class="field_left">
            <app-input
                required
                :label="translations.width"
                :error="errors.items.find(el => el.field === 'width')"
                name="width"
                type="number"
                v-model="formItem.width"
            />
            </app-settings-col>
            <app-settings-col class="field_right">
                <app-input
                    required
                    :label="translations.height"
                    :error="errors.items.find(el => el.field === 'height')"
                    name="height"
                    type="number"
                    v-model="formItem.height"
                />
            </app-settings-col>
            <app-settings-col class="field_left">
              <app-settings-control class="checkbox">
                  <app-checkbox
                  :title="translations.logo"
                  :error="errors.items.find(el => el.field === 'logo')"
                  name="logo"
                  v-model="formItem.logo"
                  />
              </app-settings-control>
              <app-settings-control>
                  <app-checkbox
                  :title="translations.thumbnail"
                  :error="errors.items.find(el => el.field === 'thumbnail')"
                  name="thumbnail"
                  v-model="formItem.thumbnail"
                  />
              </app-settings-control>
              <app-settings-control>
                  <app-checkbox
                  :title="translations.poster"
                  :error="errors.items.find(el => el.field === 'poster')"
                  name="poster"
                  v-model="formItem.poster"
                  />
              </app-settings-control>
            </app-settings-col>
            <app-settings-col class="field_right">
              <app-settings-control class="checkbox">
                  <app-checkbox
                  :title="translations.enabled"
                  :error="errors.items.find(el => el.field === 'enabled')"
                  name="enabled"
                  v-model="formItem.enabled"
                  />
              </app-settings-control>
              <app-settings-control class="checkbox">
                  <app-checkbox
                  :title="translations.isDeviceSize"
                  :error="errors.items.find(el => el.field === 'isDeviceSize')"
                  name="isDeviceSize"
                  v-model="formItem.isDeviceSize"
                  />
              </app-settings-control>
            </app-settings-col>
            <app-settings-col class="field_left">
            </app-settings-col>
          </app-settings-options>
        </app-settings-content>

        <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'image-sizes'}">
        <app-content-save-button :disabled="pending" @click="disallowBack" />
        </app-settings-buttons>
    </app-settings>
    </form>
</app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import { mapActions, mapState } from 'vuex'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'ImageSize',
  enums: true
})

export default {
  name: 'image-size',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  computed: {
    translations() {
      return {
        newImageSize: this.$gettext('Nový rozměr obrázků'),
        basicInfo: this.$gettext('Základní údaje'),
        name: this.$gettext('Název'),
        code: this.$gettext('Kód'),
        compression: this.$gettext('Komprese'),
        radius: this.$gettext('Rádius'),
        width: this.$gettext('Šířka'),
        height: this.$gettext('Výška'),
        logo: this.$gettext('Logo'),
        thumbnail: this.$gettext('Thumbnail'),
        poster: this.$gettext('Poster'),
        enabled: this.$gettext('Povoleno'),
        isDeviceSize: this.$gettext('Zobrazit na zařízení'),
        list: this.$gettext('Seznam')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Rozměry obrázků'), link: { name: 'image-sizes' } },
        this.item.name || this.$gettext('Nový rozměr obrázků')
      ]
    }
  }
}
</script>
